import { render, staticRenderFns } from "./Confirmation.vue?vue&type=template&id=5869e9ca&scoped=true"
import script from "./Confirmation.vue?vue&type=script&lang=js"
export * from "./Confirmation.vue?vue&type=script&lang=js"
import style0 from "./Confirmation.vue?vue&type=style&index=0&id=5869e9ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5869e9ca",
  null
  
)

export default component.exports